import * as React from "react";
import { Typography, Box } from "@mui/material";
import { ROUTE_COMPLETE_PROFILE } from "../../constants/routes";
import { useNavigate } from "react-router-dom";

const WelcomeNew = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    const timer = setTimeout(() => {
      navigate(ROUTE_COMPLETE_PROFILE);
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      bgcolor="#FF8960"
      overflow="hidden"
      position="relative"
    >
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/1126f612746ea514e349332d6fdd8ee9647d4fa70412460e368a6a5af3faf3f2?apiKey=80f439f9d23243918de9eba558cc207a&"
        alt="logo"
        style={{ width: "83px", height: "44px", position: "absolute", top: "20px" }}
      />
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        marginTop="50%"
        marginBottom="50%"
      >
        <Typography
          variant="h1"
          style={{ color: "#ffffff", fontFamily: "Poppins", fontSize: "35px", marginBottom: "15px" }}
        >
          Hi, I&apos;m Nina!
        </Typography>
        <Typography
          variant="body1"
          style={{ color: "#ffffff", fontFamily: "DM Sans", fontSize: "16px", marginBottom: "10px" }}
        >
          Lovely meeting you again.
        </Typography>
      </Box>
      <Box flexGrow={1} />
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/64300db3216abced4e1984c5c1c2bc0ad47b888f515ccd3cff5568b289cec3d9?apiKey=80f439f9d23243918de9eba558cc207a&"
        alt=""
        style={{ width: "100%", position: "absolute", bottom: "0", left: "0" }}
      />
    </Box>
  );
};

export default WelcomeNew;
